<style>
.coin-text {
  margin-top: 1vh;
  margin-bottom: 0vh;
  font-weight: bold;
}
</style>

<template>

  <div class="form-group form-group--three-columns">

    <div v-for="(item, index) in coindistributionsetting" class="form-row">

      <p class="coin-text">{{parseFloat(coindistributionsetting[index].value/100).toFixed(2) + " " + coindistributionsetting[index].currency}}</p>
      <el-select v-model="coindistributionsetting[index].location" @change="updateSettings()" :disabled="!overridden || readOnly">
          <el-option :value="1"></el-option>
          <el-option :value="2"></el-option>
      </el-select>

    </div>

  </div>

</template>

<script>

  export default {
    name: 'DqCoindistributionpanel',
    replace: true,
    props: {
      overridden: false,
      coindistributionsetting: [],
      readOnly: false
    },
    data: function () {
      return {
        coinDistributionSettingNew: [...this.coindistributionsetting]
      }
    },
    mounted () {
      this.updateSettings()
    },
    watch: {
      coinDistributionSettings: function () {
        this.updateSettings()
      }
    },
    methods: {
      updateSettings () {
        this.coinDistributionSettingNew = [...this.coindistributionsetting]
        this.$store.commit('overrideCoinDistributionSetting/setOverrideCoinDistributionSetting', { coinDistributionSetting: this.coinDistributionSettingNew })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// coindistributionpanel.vue?7d4ac0df